import actions from '../../actionTypes';

export default action => {
  return {
    type: actions.EDITED_ACTION,
    action
  };
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/actions/editedAction.js